export const ADD = 'WIDGET.ADD';
export const DELETE = 'WIDGET.DELETE';
export const UPDATE = 'WIDGET.UPDATE';
export const UPDATE_SETTINGS = 'WIDGET.UPDATE_SETTINGS';
export const UPDATE_ALL = 'WIDGET.UPDATE_ALL';


// WEBPACK FOOTER //
// ./src/constants/Widget.ts